// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1bUWU","productName":"Table_productName__3iYMX"};